import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { meQuery } from "~/lib/auth";

/** Public auth screens; signed-in, onboarded users go straight to the app. */
export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (me?.onboarded) throw redirect({ to: "/dashboard" });
  },
  component: Outlet,
});
